import React from 'react';
import {IArticleTable} from '../../redux/article/interfaces';

import './styles.scss';

interface TableViewProps {
  table: IArticleTable;
}

const TableView: React.FC<TableViewProps> = ({table}) => {
  const {caption, notes, structure} = table;

  return (
    <div className="article-table">
      <h2 className="article-table__caption">
        {caption}
      </h2>
      {notes && <p className="article-table__notes">{notes}</p>}
      <div className="article-table__container">
        <table className="article-table__table">
          <thead>
            <tr>
              {structure.columns && structure.columns.map((col) => (
                <th key={col} className="article-table__table-header">
                  {col}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {structure.rows && structure.rows.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {structure.columns && structure.columns.map((col) => (
                  <td key={col} className="article-table__table-row">
                    {row[col]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TableView;
